export const styles = {
  icon: {
    marginTop: '5px',
  },
  units: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    color: '#354052',
    marginTop: '17px',
    marginLeft: '3px',
  },
  value: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '32px',
    color: '#354052',
    marginLeft: '10px',
  },
  leftColUpperRowDescriptionSubRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#7f8fa4',
  },
  leftColBottomRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    borderTop: '1px solid #c5d0de',
  },
  rightColumnRow: {
    borderBottom: '1px solid #c5d0de',
  },
  valueAndUnitWrapper: {
    marginRight: '5px',
  },
  rightColumnRowValueSubRowItemIcon: {},
  rightColumnRowValueSubRowItemUnits: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#354052',
    marginTop: '5px',
  },
  rightColumnRowValueSubRowItemValue: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#354052',
    marginRight: '5px',
  },
  rightColumnRowDescriptionSubRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#7f8fa4',
  },
};
